import type { ReactNode } from "react";
import { AzioniBarra, TastoBarra } from "@/shared/layout/MobileTopBar";
import { BottomSheet } from "@/shared/ui/BottomSheet";
import type { bonificoSelezione } from "../bonificoSelezione";

/** Telefono: i tasti Sincronizza / Azioni in basso, con una selezione
 *  attiva la barra col conteggio sopra la navigazione, e il foglio Azioni. */
export function OrdiniBarraMobile({
  syncBusy,
  onSync,
  selezionati,
  bonifico,
  onAnnulla,
  onAzioni,
  azioniAperte,
  onChiudiAzioni,
  children,
}: {
  syncBusy: boolean;
  onSync: () => void;
  selezionati: number;
  bonifico: ReturnType<typeof bonificoSelezione>;
  onAnnulla: () => void;
  onAzioni: () => void;
  azioniAperte: boolean;
  onChiudiAzioni: () => void;
  /** Il contenuto del foglio Azioni: tasti, esiti, ritiri. */
  children: ReactNode;
}) {
  return (
    <>
      <AzioniBarra>
        <TastoBarra label="Sincronizza ordini e mail fornitori" busy={syncBusy} onClick={onSync}>
          <svg
            className="h-[22px] w-[22px]"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.8}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M21 12a9 9 0 0 1-15.3 6.4L3 16M3 12a9 9 0 0 1 15.3-6.4L21 8M21 3v5h-5M3 21v-5h5" />
          </svg>
        </TastoBarra>
        <TastoBarra label="Azioni sugli ordini" badge={selezionati} onClick={onAzioni}>
          <svg
            className="h-[22px] w-[22px]"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.8}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          </svg>
        </TastoBarra>
      </AzioniBarra>

      {/* Selezione attiva: barra appoggiata sopra la navigazione, col
          conteggio e la strada per le azioni di gruppo. */}
      {selezionati > 0 && (
        <div className="sticky bottom-3 z-30 mt-2 flex items-center gap-2 rounded-2xl bg-ink py-2 pl-4 pr-2 text-on-ink shadow-[0_8px_24px_rgba(31,27,22,0.28)]">
          <div className="flex min-w-0 flex-1 flex-col">
            <span className="text-[15px] font-bold">
              {selezionati} selezionat{selezionati === 1 ? "o" : "i"}
            </span>
            {bonifico.totaleLordo > 0 && (
              <span
                className="truncate text-[12.5px] text-white/85"
                data-testid="bonifico-selezione"
              >
                da bonificare €{" "}
                {bonifico.totaleLordo.toLocaleString("it-IT", { minimumFractionDigits: 2 })} IVA
                incl.
                {bonifico.senzaCosto > 0 ? ` · ${bonifico.senzaCosto} senza costo` : ""}
              </span>
            )}
          </div>
          <button
            type="button"
            onClick={onAnnulla}
            className="om-press h-11 rounded-xl px-3 text-[14px] font-semibold text-white/90 active:bg-white/10"
          >
            Annulla
          </button>
          <button
            type="button"
            onClick={onAzioni}
            className="om-press h-11 rounded-xl bg-card px-4 text-[15px] font-bold text-ink"
          >
            Azioni
          </button>
        </div>
      )}
      <BottomSheet
        open={azioniAperte}
        onClose={onChiudiAzioni}
        title={
          selezionati > 0
            ? `Azioni · ${selezionati} ${selezionati === 1 ? "ordine" : "ordini"}`
            : "Azioni"
        }
      >
        {selezionati === 0 && (
          <p className="mb-3 rounded-xl bg-paper-2 px-3.5 py-3 text-[14px] text-ink">
            Seleziona gli ordini dalla lista per ordinarli al fornitore, generare le LDV o cambiarne
            lo stato. Sincronizza funziona sempre.
          </p>
        )}
        {children}
      </BottomSheet>
    </>
  );
}
